import { useQuery } from "@tanstack/react-query";
import { getWholesaleCustomerSegmentation } from "../services/wholesaleCustomerSegmentationService";

export const useWholesaleCustomerSegmentation = () => {
  return useQuery({
    queryKey: ["wholesale-customer_segmentation"],
    queryFn: getWholesaleCustomerSegmentation,
    staleTime: 1000 * 60 * 5,
  });
};
